import { useEffect } from 'react';
import { Common } from '@thecvlb/design-system';

import { BaseModalProps } from 'modals/modal.types';

type Props = BaseModalProps & {
  loading?: boolean;
  onConfirm: () => void;
};

const CancelOnboarding: React.FC<Props> = ({ isOpen, onClose, onConfirm, loading }) => {
  useEffect(() => {
    const onClickEnter = (e: KeyboardEvent) => {
      if (e.key === 'Enter' && isOpen) {
        onConfirm();
      }
    };
    document.addEventListener('keyup', onClickEnter);
    return () => {
      document.removeEventListener('keyup', onClickEnter);
    };
  }, []);

  return (
    <Common.Modal close={onClose} isOpen={isOpen} padding={false} persist={loading} size="base">
      <div className="flex flex-col gap-6 p-4">
        <h3 className="text-mLg font-bold">Cancel sign-up</h3>
        <p className="text-base">You’ll have to start again.</p>
        <div className="flex flex-col-reverse gap-3 md:flex-row">
          <Common.Button
            className="grow"
            color="white-alt"
            dataTestId="cancel_btn"
            disabled={loading}
            fullWidthOnMobile
            onClick={onClose}
          >
            Continue without insurance
          </Common.Button>
          <Common.Button
            className="grow"
            color="red"
            dataTestId="confirm_on_popup_btn"
            disabled={loading}
            isLoading={loading}
            fullWidthOnMobile
            onClick={onConfirm}
          >
            Cancel sign-up
          </Common.Button>
        </div>
      </div>
    </Common.Modal>
  );
};

export default CancelOnboarding;
